import React, { useState, useEffect } from "react";
import { View, StyleSheet, FlatList, TouchableOpacity, Text, Image, Dimensions, ScrollView, ActivityIndicator } from "react-native";
const Gallery = (props) => {
    const [datagallery, setGalleryData] = useState([]);





    React.useEffect(() => {
        fetch('https://app.arshehkar.com/query/public/GetCategoryGallery.php')
            .then(response => response.json())
            .then(async (datagallery) => {
                setGalleryData(datagallery);
            });

    }, []);

    return (
        <ScrollView>
            <View style={{ backgroundColor: '#e6e6e6', flex: 1, width: '100%', justifyContent: 'center' }}>
                {
                    !datagallery ?
                        <ActivityIndicator size="large" color='blue' />
                        :
                        <FlatList
                            numColumns={2}
                            data={datagallery}
                            style={{ margin: 7 }}
                            renderItem={({ item }) =>
                                <View style={styles.listRow} key={item.key}>
                                    <TouchableOpacity onPress={() => props.navigation.navigate('GalleryDetail', { gallery: item })}>
                                        <Image style={styles.img} source={'https://app.qrpanel.net/gallery/category/' + item.id + '.jpg'} />
                                        <Text style={styles.title}>{item.title}</Text>

                                    </TouchableOpacity>
                                </View>




                            }
                        />
                }

            </View>
        </ScrollView>
    )
}


const styles = StyleSheet.create(
    {
        listRow: {
            display: 'block',
            height: 150,
            margin: 6,
            backgroundColor: '#fff',
            color: '#fff',
            borderRadius: 6,
            maxWidth: Dimensions.get('window').width / 2,
            flex: 0.5,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
            justifyContent: 'center',
            width: '100%'

        }
        ,
        title: {


            textAlignVertical: 'center',
            padding: 5,
            fontFamily: 'IranSans',
            fontSize: 13,
            textAlign: 'center'
        }
        ,
        img: {
            width: "100%",
            height: 115,
            borderRadius: 6,
            resizeMode: 'cover  ',
            alignSelf: 'center',


        },
        spinner: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(50,70,110,0.3)',
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9000,
        }
    }
)
export default Gallery;